import { SlideTypeEnum } from '../modules/carousel/enums/slide-type';
import { ISlideData } from '../modules/carousel/interfaces';
import { CHART_TYPES, charts } from './charts';
import { TEST_IMAGE_TYPES, images } from './images';

export enum TEST_HINT_TYPES {
  SINGLE_SHORT,
  SINGLE_MEDIUM,
  SINGLE_LONG,
  DOUBLE_SHORT,
  DOUBLE_MEDIUM,
  MULTIPLE_MEDIUM,
  SINGLE_SHORT_TARGET_TEXT,
  SINGLE_MEDIUM_TARGET_TEXT,
  DOUBLE_SHORT_TARGET_TEXT,
  DOUBLE_MEDIUM_TARGET_TEXT,
  ES_SINGLE_SHORT,
  ES_SINGLE_MEDIUM,
  ES_SINGLE_LONG,
  ES_DOUBLE_MEDIUM,
  ES_MULTIPLE_MEDIUM,
}

export const chartHints: { [key: number]: ISlideData[] } = {
  [TEST_HINT_TYPES.SINGLE_SHORT]: [
    {
      id: '0',
      type: SlideTypeEnum.chartSlide,
      data: {
        title: 'Chart hint here',
        chartData: charts[CHART_TYPES.SAMPLE_WITH_TITLE],
      },
    },
  ],
  [TEST_HINT_TYPES.SINGLE_MEDIUM]: [
    {
      id: '0',
      type: SlideTypeEnum.chartSlide,
      data: {
        title:
          'Chart hint here chart hint here chart hint here chart hint here',
        chartData: charts[CHART_TYPES.SAMPLE_WITHOUT_TITLE],
      },
    },
  ],
  [TEST_HINT_TYPES.SINGLE_LONG]: [
    {
      id: '0',
      type: SlideTypeEnum.chartSlide,
      data: {
        title:
          'Chart hint here Chart hint here Chart hint here Chart hint here Chart hint here Chart hint here Chart hint here',
        chartData: charts[CHART_TYPES.SAMPLE_WITHOUT_TITLE],
      },
    },
  ],
  [TEST_HINT_TYPES.DOUBLE_SHORT]: [
    {
      id: '0',
      type: SlideTypeEnum.chartSlide,
      data: {
        title: 'This is your first short chart hint',
        chartData: charts[CHART_TYPES.SAMPLE_WITHOUT_TITLE],
      },
    },
    {
      id: '1',
      type: SlideTypeEnum.chartSlide,
      data: {
        title: 'This is your second short chart hint',
        chartData: charts[CHART_TYPES.SAMPLE_WITHOUT_TITLE],
      },
    },
  ],
  [TEST_HINT_TYPES.DOUBLE_MEDIUM]: [
    {
      id: '0',
      type: SlideTypeEnum.chartSlide,
      data: {
        title:
          'This is the first medium length chart hint. pretend this is good advice.',
        chartData: charts[CHART_TYPES.SAMPLE_WITHOUT_TITLE],
      },
    },
    {
      id: '1',
      type: SlideTypeEnum.chartSlide,
      data: {
        title:
          'This is the second medium length chart hint. pretend this is really good advice.',
        chartData: charts[CHART_TYPES.SAMPLE_WITHOUT_TITLE],
      },
    },
  ],
  [TEST_HINT_TYPES.ES_SINGLE_SHORT]: [
    {
      id: '0',
      type: SlideTypeEnum.chartSlide,
      data: {
        title: 'Yo hablo Español',
        chartData: charts[CHART_TYPES.EXPERIMENTAL],
      },
    },
  ],
  [TEST_HINT_TYPES.ES_SINGLE_MEDIUM]: [
    {
      id: '0',
      type: SlideTypeEnum.chartSlide,
      data: {
        title: 'Yo hablo Español Yo hablo Español Yo hablo Español',
        chartData: charts[CHART_TYPES.EXPERIMENTAL],
      },
    },
  ],
};

export const hints: { [key: number]: ISlideData[] } = {
  [TEST_HINT_TYPES.SINGLE_SHORT]: [
    {
      id: '0',
      type: SlideTypeEnum.basicSlide,
      data: {
        title: 'This is a single short hint.',
      },
    },
  ],
  [TEST_HINT_TYPES.SINGLE_MEDIUM]: [
    {
      id: '0',
      type: SlideTypeEnum.basicSlide,
      data: {
        title:
          'This is a single medium length hint. answer correctly this time.',
      },
    },
  ],
  [TEST_HINT_TYPES.SINGLE_LONG]: [
    {
      id: '0',
      type: SlideTypeEnum.basicSlide,
      data: {
        title:
          'This is a really really long hint. I may just talk and talk and talk forever. you never know when it will stop. nope not yet.........ok bye',
      },
    },
  ],
  [TEST_HINT_TYPES.DOUBLE_MEDIUM]: [
    {
      id: '0',
      type: SlideTypeEnum.basicSlide,
      data: {
        title:
          'This is the first medium length hint. pretend this is good advice.',
        imgData: images[TEST_IMAGE_TYPES.CAT_BESIDE_TABLE],
      },
    },
    {
      id: '1',
      type: SlideTypeEnum.basicSlide,
      data: {
        title:
          'This is the second medium length hint. pretend this is great advice.',
      },
    },
  ],
  [TEST_HINT_TYPES.MULTIPLE_MEDIUM]: [
    {
      id: '0',
      type: SlideTypeEnum.basicSlide,
      data: {
        title:
          'This is the first of three medium length hints. what a great hint',
        imgData: images[TEST_IMAGE_TYPES.CAT_BESIDE_TABLE],
      },
    },
    {
      id: '1',
      type: SlideTypeEnum.basicSlide,
      data: {
        title:
          'This is the second of three medium length hints. even better than the first.',
        imgData: images[TEST_IMAGE_TYPES.CAT_UNDER_TABLE],
      },
    },
    {
      id: '2',
      type: SlideTypeEnum.basicSlide,
      data: {
        title:
          'This is the third of three medium length hints. last one, I promise.',
      },
    },
  ],
  [TEST_HINT_TYPES.ES_SINGLE_SHORT]: [
    {
      id: '0',
      type: SlideTypeEnum.basicSlide,
      data: {
        title: 'Inserte la primera pista aquí (1)',
      },
    },
  ],
  [TEST_HINT_TYPES.ES_SINGLE_MEDIUM]: [
    {
      id: '0',
      type: SlideTypeEnum.basicSlide,
      data: {
        title:
          'Inserte la primera pista aquí (1) Inserte la primera pista aquí (1) Inserte la primera pista aquí (1)',
      },
    },
  ],
  [TEST_HINT_TYPES.ES_SINGLE_LONG]: [
    {
      id: '0',
      type: SlideTypeEnum.basicSlide,
      data: {
        title:
          'Inserte la primera pista aquí (1) Inserte la primera pista aquí (1) Inserte la primera pista aquí (1) Inserte la primera pista aquí (1) Inserte la primera pista aquí (1) Inserte la primera pista aquí (1)',
      },
    },
  ],
  [TEST_HINT_TYPES.ES_DOUBLE_MEDIUM]: [
    {
      id: '0',
      type: SlideTypeEnum.basicSlide,
      data: {
        title: 'Inserte la primera pista aquí (1)',
        imgData: images[TEST_IMAGE_TYPES.CAT_BESIDE_TABLE],
      },
    },
    {
      id: '1',
      type: SlideTypeEnum.basicSlide,
      data: {
        title:
          'Inserte la primera pista aquí (1) Inserte la primera pista aquí (1) Inserte la primera pista aquí (1) Inserte la primera pista aquí (1) Inserte la primera pista aquí (1) Inserte la primera pista aquí (1)',
      },
    },
  ],
  [TEST_HINT_TYPES.ES_MULTIPLE_MEDIUM]: [
    {
      id: '0',
      type: SlideTypeEnum.basicSlide,
      data: {
        title: 'Inserte la primera pista aquí (1)',
        imgData: images[TEST_IMAGE_TYPES.CAT_BESIDE_TABLE],
      },
    },
    {
      id: '1',
      type: SlideTypeEnum.basicSlide,
      data: {
        title: 'Inserte la primera pista aquí (2)',
        imgData: images[TEST_IMAGE_TYPES.CAT_UNDER_TABLE],
      },
    },
    {
      id: '2',
      type: SlideTypeEnum.basicSlide,
      data: {
        title:
          'Inserte la primera pista aquí (1) Inserte la primera pista aquí (1) Inserte la primera pista aquí (1) Inserte la primera pista aquí (1) Inserte la primera pista aquí (1) Inserte la primera pista aquí (1)',
      },
    },
  ],
  [TEST_HINT_TYPES.SINGLE_SHORT_TARGET_TEXT]: [
    {
      id: '0',
      type: SlideTypeEnum.basicSlide,
      data: {
        title: 'Try saying the word out loud. {TARGET_TEXT}.',
      },
    },
  ],
  [TEST_HINT_TYPES.DOUBLE_SHORT_TARGET_TEXT]: [
    {
      id: '0',
      type: SlideTypeEnum.basicSlide,
      data: {
        title: 'First hint. The word is: {TARGET_TEXT}.',
      },
    },
    {
      id: '1',
      type: SlideTypeEnum.basicSlide,
      data: {
        title: 'Second hint. The word is: {TARGET_TEXT}.',
      },
    },
  ],
};
